// extracted by mini-css-extract-plugin
export default {"container":"IFM+aUmHat","icon":"CI+sNupn4J","title-section-container":"MhnSbTLrVl","titleSectionContainer":"MhnSbTLrVl","title-section":"_3U+GUsN28s","titleSection":"_3U+GUsN28s","title":"y9rQ+Pxfes","id":"eu1ieZOxdR","id-prefix":"bg9l+VWk-+","idPrefix":"bg9l+VWk-+"};
    if(module.hot) {
      // 1643570457126
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  